module.exports = __webpack_public_path__ + "static/media/teste.72877e50.png";